export default __webpack_public_path__ + "static/media/masvivo.bf6c7a9a.png";